export default __webpack_public_path__ + "static/media/orange.9e5492ea.jpg";